module.exports = __webpack_public_path__ + "media/images/icons/side_menu_correggere-4f770741e915b500154ab7f8b35d5b9f.svg";